import { Currency } from "./types";

const LOCALE_BY_CURRENCY: Record<Currency, string> = { BRL: "pt-BR" };

export function formatCurrency(amount: number, currency: Currency = "BRL"): string {
  const hasCents = Math.abs(amount % 1) > 0.004;
  return new Intl.NumberFormat(LOCALE_BY_CURRENCY[currency] || "pt-BR", {
    style: "currency",
    currency,
    minimumFractionDigits: hasCents ? 2 : 0,
    maximumFractionDigits: 2,
  })
    .format(amount)
    .replace(/\u00a0/g, " ");
}

export const formatPaxRange = (minPax: number, maxPax: number) =>
  minPax === maxPax ? `${minPax}` : `${minPax}–${maxPax}`;
